import $http from '@/api/index'
import axios from 'axios'

//加入保留后将客户机设置为动态获取IP
export function EnabledDHCP(info){
  let options = {
    method: 'POST',
    url: 'TMS/EnabledDHCP',
    requestType: 2
  }
  return $http(options, info)
}

//将静态IP设备加入保留地址
export function CreateReservationEx(info){
  let options = {
    method: 'POST',
    url: 'DHCP/CreateReservationEx',
    requestType: 2
  }
  return $http(options, info)
}

/*
	获取dhcp授权信息
*/
export function getDhcpRequest(state) {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/GetDhcpRequest',
    requestType: 2
  };
  let params = {
    "state": state
  };
  return $http(getUrl, params);
}

/*
	根据id获取dhcp授权信息
*/
export function getDhcpRequestById(id) {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/GetDhcpRequestById',
    requestType: 2
  };
  let params = {
    "id": id
  };
  return $http(getUrl, params);
}

/*
	根据taskId获取dhcp授权信息
*/
export function getDhcpRequestByTaskId(taskId) {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/GetDhcpRequestByTaskId',
    requestType: 2
  };
  let params = {
    "taskId": taskId
  };
  return $http(getUrl, params);
}

/*
	新增dhcp授权
*/
export function saveDhcpRequest(data) {
  let getUrl = {
    method: 'POST',
    url: "DHCP/SaveDhcpRequest",
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	查询dhcp授权信息 通过查询条件
*/
export function queryDhcpRequest(state) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpRequest',
    requestType: 2
  };
  let params = state;
  return $http(getUrl, params);
}

/*
	查询dhcp授权信息 通过查询条件
*/
export function queryDhcpDevice(state) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpDevice',
    requestType: 2
  };
  let params = state;
  return $http(getUrl, params);
}

/*
	获取dhcp授权方式
*/
export function getDhcpAuthType() {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/GetDhcpAuthType',
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
	设置dhcp授权方式
*/
export function setDhcpAuthType(authType) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/SetDhcpAuthType/?authType=' + authType,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
	检测IP地址是否存在
*/
export function checkIP(ip) {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/Ping/?ip=' + ip,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
	查询dhcp服务器
*/
export function queryDhcpServer(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpServer',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	查询dhcp作用域
*/
export function queryDhcpPool(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpPool',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	查询dhcp作用域
*/
export function queryDhcpSubnet(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpSubNet',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	查询dhcp租用地址
*/
export function queryDhcpInUse(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpInUse',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	查询dhcp保留地址
*/
export function queryDhcpReserve(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpReserve',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	注册dhcp服务器
*/
export function regDHCPServer(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RegDHCPServer',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	删除dhcp服务器
*/
export function delDHCPServer(dhcpServer) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/DelDHCPServer?dhcpServer=' + dhcpServer,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
	修改dhcp服务器
*/
export function updateDHCPServer(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/UpdateDHCPServer',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
	更改准入规则
*/
export function changeServerAuthType(dhcpServer, authType) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/ChangeServerAuthType?dhcpServer=' + dhcpServer + '&authType=' + authType,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
	更改准入规则
*/
export function changePoolAuthType(dhcpServer, netAddress, authType) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/ChangePoolAuthType?dhcpServer=' + dhcpServer + '&netAddress=' + netAddress + '&authType=' + authType,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  创建作用域
*/
export function createSubnet(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/CreateSubnet',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  移除作用域
*/
export function removeSubnet(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RemoveSubnet',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  创建例外
*/
export function createExclusion(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/CreateExclusion',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  移除例外
*/
export function removeExclusion(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RemoveExclusion',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  获取所有DHCP服务器
*/
export function getAllDhcpServer() {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/GetAllDhcpServer',
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  更新作用域 启用/停用
*/
export function updateSubnet(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/UpdateSubnet',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  移除租期内客户机
*/
export function removeInUse(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RemoveInUse',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  创建保留
*/
export function createReservation(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/CreateReservation',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  删除保留
*/
export function removeReservation(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RemoveReservation',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  查询备份
*/
export function queryDhcpBackup(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/QueryDhcpBackup',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  创建备份
*/
export function createBackup(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/CreateBackup',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  删除备份
*/
export function deleteBackup(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/DeleteBackup',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  下载备份文件
*/
export function downloadBackup(id) {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/DownloadBackup/?id=' + id,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  恢复备份
*/
export function recoveryBackup(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RecoveryBackup',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  恢复备份通过文件
*/
export function recoveryBackupByFile(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/RecoveryBackupByFile',
    requestType: 2
  };
  return $http(getUrl, data);
}

/*
  保存到数据库
*/
export function save2DB(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/Save2DB/?dhcpServer=' + data,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  判断ip是否在保留
*/
export function existsIpInRetain(ip){
  let getUrl = {
    method: 'GET',
    url: 'DHCP/ExistsIpInRetain/?ip=' + ip,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  下载模板文件
*/
export function downloadTemplate() {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/DownloadTemplate',
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  导入数据库
*/
export function importDB(data) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/import?user=' + data,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
  是否有审核权限
*/
export function allowAudit(code) {
  let getUrl = {
    method: 'GET',
    url: 'DHCP/AllowAudit?code='+code,
    requestType: 2
  };
  let params = {};
  return $http(getUrl, params);
}

/*
	导出设备
*/
export function downloadDhcpDevice(state) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/DownloadDhcpDevice',
    requestType: 2
  };
  let params = state;
  return $http(getUrl, params);
}

/*
	导出黑白名单
*/
export function downloadDhcpRequest(state) {
  let getUrl = {
    method: 'POST',
    url: 'DHCP/DownloadDhcpRequest',
    requestType: 2
  };
  let params = state;
  return $http(getUrl, params);
}

/**
 * 导出在用地址
 * @param {Object} state
 */
export function DownloadDhcpInUse(state){
  let getUrl = {
    method: 'POST',
    url: 'DHCP/DownloadDhcpInUse',
    requestType: 2
  };
  let params = state;
  return $http(getUrl, params);
}
